import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.dataset.videoFormat == 'mjpg') {
      this.renderMJPEGPlayer();
    } else {
      this.renderClaprPlayer();
    }
  }

  renderMJPEGPlayer() {
    const { snapshotPath, source, seek } = this.element.dataset;

    new MJPEGPlayer(this.element, source, snapshotPath)
  }

  renderClaprPlayer() {
    const { snapshotPath, source, seek, recordingId, eventId } = this.element.dataset;
    const self = this;
    const player = new Clappr.Player({
      parent: this.element,
      mimeType: 'video/mp4',
      source: source,
      width: '100%',
      height: '100%',
      autoPlay: false,
      poster: snapshotPath,
      preload: 'none',
      exitFullscreenOnEnd: false,
      plugins: {
        core: [ClapprThumbnailsPlugin]
      },
      events: {
        onReady: function() {
          // Make thumbnails bigger for large players
          const player = this
          setTimeout(() => {
            if (self.element.offsetHeight > 600) player.getPlugin("scrub-thumbnails").options.scrubThumbnails.spotlightHeight = 180
          }, 1000)
        },
        onPlay: function() {
          if (!self.thumbnailsLoaded) {
            self.thumbnailsLoaded = true
            try {
              if (recordingId) {
                self.fetchThumbnails(`/recordings/${recordingId}/timelapses?type=json`, this)
              } else if (eventId) {
                self.fetchThumbnails(`/events/${eventId}/timelapses?type=json`, this)
              }
            } catch (e) {
              console.log(e)
            }
          }
        }
      },
      playback: {
        hlsjsConfig: { maxBufferLength: 5 },
        playInline: true,
        crossOrigin: 'anonymous'
      },
      scrubThumbnails: {
        backdropHeight: 54,
        spotlightHeight: 84,
        thumbs: []
      }
    });

    player.seek(parseInt(seek) || 0);
  }

  fetchThumbnails(path, player) {
    Api.get(path, (response) => {
      const count = response.length;
      const interval = player.getDuration() / count;

      response.map((obj, index) => {
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          try {
            const dataUrl = canvas.toDataURL('image/jpeg');
            player.getPlugin("scrub-thumbnails").addThumbnail({
              time: parseFloat((interval * index).toFixed(2)),
              url: dataUrl,
              hasCar: obj.has_car,
              hasBicycle: obj.has_bicycle,
              hasPerson: obj.has_person,
              hasAnimal: obj.has_animal
            })
          } catch (err) {}
        };

        img.src = obj.url;
      })
    })
  }
}
